var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show_csr_warning)?_c('div',{staticClass:"csr-header-warning text-center"},[_vm._v(" "+_vm._s(_vm.l.t('app.you-are-in-csr-mode', 'You are in CSR mode'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }